import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ecad6a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spot" }
const _hoisted_2 = { class: "spot-inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle circle--outline" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle circle--outline" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_6 = { class: "icon-wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-background" }, null, -1))
const _hoisted_8 = { class: "icon" }

import { computed, onMounted, onUnmounted, PropType, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import gsap from 'gsap'

import { useAppState } from '@/services/composition'
import { useGameState } from '@/services/composition'
import { Hotspot, useScreenHotspots } from '@/services/stores/hotspots'
import { useDoors } from '@/services/stores/doors'

import frames from '@/utils/FrameToTime'
import AudioManager, { AUDIO_ID } from '@/core/audio/AudioManager'
import AppService from '@/services/AppService'
import DesktopActivity from '@webgl/activities/desktop/DesktopActivity'
import Viewport, { disposeViewport } from '@/store/modules/Viewport'

import DesktopHotspotDetails from './DesktopHotspotDetails.vue'
import UITemperatureIndicator from '@/components/UITemperatureIndicator/UITemperatureIndicator.vue'
import { HotspotId } from '@/services/states/GameContextDatas'


export default /*#__PURE__*/_defineComponent({
  props: {
  hotspot: {
    type: Object as PropType<Hotspot>,
    required: true
  }
},
  setup(__props) {

const props = __props

const state = useGameState()

const { t } = useI18n()
const { send } = useAppState()
const { findHotspot: findScreenHotspot } = useScreenHotspots()
const { findDoor } = useDoors()




const el = ref(null)

const inFog = computed(() => {
  return props.hotspot.mustCrouch && !state.value.context.isCrouched
})

const isDone = computed(() => {
  return state.value.context.hotspots.includes(props.hotspot.id)
})

const position = computed(() => {
  return findScreenHotspot(props.hotspot.id).position
})

const transform = computed(() => {
  return { left: `${position.value[0]}px`, top: `${position.value[1]}px` }
})

const isExit = computed(() => {
   return state.value.matches('tuto.xr.exit_room') || state.value.matches('game.bedroom.exit_room') || state.value.matches('game.corridor.exit_room') || state.value.matches('game.studyroom.exit_room') || state.value.matches('game.living.exit_room')
})

onMounted(() => {
  createRippleTL()
})

onUnmounted(() => {
  rippleTL.value?.kill()
})

const rippleTL: GSAPTimeline = ref(null)
function createRippleTL() {
  const $ = gsap.utils.selector(el.value)
  rippleTL.value?.kill()

  const tl =  gsap.timeline(
    {
      // onComplete() {
      //   if(!hover.value) {
      //     this.restart()
      //   }
      // },
      repeat: -1,
      paused: true
    }
  )
  tl.fromTo(
    $('.spot .circle--outline'),
    {
      scale: 1,
      opacity: 1
    },
    {
      scale: 96 / 40,
      opacity: 0,
      duration: frames(60),
      stagger: frames(5),
      ease: 'quint.inOut'
    }
  )

  rippleTL.value = tl
}

const hoverTL: GSAPTimeline = ref(null)
function createHoverTL() {
  const $ = gsap.utils.selector(el.value)

  hoverTL.value?.kill()

  const tl = gsap.timeline({ paused: true })
  tl.addLabel('start')
  tl.fromTo(
    [$('.spot-inner .icon-background')[0], $('.spot-inner .icon')[0]],
    {
      scale: 0,
      rotate: -90
    },
    {
      scale: 1,
      rotate: 0,
      duration: frames(20),
      stagger: frames(5),
      ease: 'quint.inOut'
    },
    'start'
  )
  tl.from(
    $('.spot .icon svg')[0],
    {
      opacity: 0,
      duration: frames(30),
    },
    `start+=${frames(10)}`
  )

  hoverTL.value = tl
}

const handleClick = async () => {
  if (Viewport.isMobile) {
    if (props.hotspot.id === HotspotId.Step0_Door && state.value.matches('tuto.xr.door')) {
      send('GAME_ACTION_DONE')
    }
    if (hover.value) {
      send({ type: 'GAME_HOTSPOT_HOVER', payload: -1 })
    } else {
      send({ type: 'GAME_HOTSPOT_HOVER', payload: props.hotspot.id })
    }
  } else {
    (AppService.glapp.activity as DesktopActivity).hotspots.handleClick()
  }
}

const hover = computed(() => {
  return state.value.context.hotspotHovered === props.hotspot.id
})

const handleHover = ({ type }: MouseEvent) => {
  if (Viewport.isMobile) {
    return
  }
  if (type === 'mouseenter') {
    send({ type: 'GAME_HOTSPOT_HOVER', payload: props.hotspot.id })
  } else {
    send({ type: 'GAME_HOTSPOT_HOVER', payload: -1 })
  }
}

watch(hover, () => {
  if(hover.value) {
    hoverTL.value?.timeScale(1).play()
    rippleTL.value?.pause(0)

    AudioManager.play(AUDIO_ID.UI_HOVER)
  } else {
    hoverTL.value?.timeScale(1.5).reverse()
    if(!isDone.value) {
      rippleTL.value?.restart()
    }
  }
})

watch(isDone, () => {
  if(isDone.value) {
    rippleTL.value?.pause(0)
  }
})

async function onEnter(el: HTMLElement, onComplete: gsap.Callback) {
  if (Viewport.isDesktop) {
    createHoverTL()
  }
  const $ = gsap.utils.selector(el)
  const tl = gsap.timeline({ onComplete })
  tl.fromTo($('.spot-inner'), { scale: 0.01 }, { scale: 1, duration: frames(30), ease: 'quint.inOut' })

  AudioManager.play(AUDIO_ID.UI_HOTSPOT)
}

function onAfterEnter() {
  rippleTL.value.play()
}

function onLeave(el: HTMLElement, onComplete: gsap.Callback) {
  const $ = gsap.utils.selector(el)
  const tl = gsap.timeline({ onComplete })
  tl.to($('.spot-inner'), { scale: 0, duration: frames(30), ease: 'quint.in' })
}

const showTemperatureIndicator = computed(()=>{
  return hasLinkedDoor.value && door.value && Viewport.isMobile && hover.value
})

const hasLinkedDoor = computed(() => {
  return props.hotspot.linkedDoor !== undefined
})

const door = computed(() => {
  if ((!state.value.matches('game') && !state.value.matches('tuto'))) return null

  const id = hasLinkedDoor.value ? props.hotspot?.linkedDoor : -1
  if (id === -1) return null

  const door = findDoor(id)
  if (door.states.some(hState => state.value.matches(hState))) {
    return door
  }
  return null
})

const temperatureIndicatorText = computed(() => {
  return t(`game.temperature.${door.value?.temperature}`)
})

const temperatureIndicatorClass = computed(() => {
  return [door.value?.temperature]
})

const onEnterIndicator = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })
  tl.fromTo(el, { scale: 0 }, { scale: 1, duration: 0.4 })
}

const onLeaveIndicator = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })
  tl.to(el, { scale: 0, duration: 0.4 })
}

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    css: false,
    appear: "",
    onEnter: onEnter,
    onAfterEnter: onAfterEnter,
    onLeave: onLeave
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["hotspot", { isDone: _unref(isDone), inFog: _unref(inFog) }]),
        ref_key: "el",
        ref: el,
        style: _normalizeStyle(_unref(transform)),
        onClick: handleClick,
        onMouseenter: handleHover,
        onMouseleave: handleHover
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_ui_icon, {
                  name: __props.hotspot.icon
                }, null, 8, ["name"])
              ])
            ])
          ])
        ]),
        _createVNode(_Transition, {
          css: false,
          onEnter: onEnterIndicator,
          onLeave: onLeaveIndicator
        }, {
          default: _withCtx(() => [
            (_unref(showTemperatureIndicator))
              ? (_openBlock(), _createBlock(UITemperatureIndicator, {
                  key: 0,
                  text: _unref(temperatureIndicatorText),
                  class: _normalizeClass(_unref(temperatureIndicatorClass))
                }, null, 8, ["text", "class"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(DesktopHotspotDetails, _normalizeProps(_guardReactiveProps({ icon: __props.hotspot.icon, title: _unref(t)(`hotspots.${__props.hotspot.name}.label`), hover: true })), null, 16), [
          [_vShow, _unref(hover)]
        ])
      ], 38)
    ]),
    _: 1
  }))
}
}

})